import { Modal } from "antd";
import Button from "../../../../components/common/button";
import Dropdown from "../../../../components/common/dropdown";
import { useEffect, useState } from "react";
import {
  getLookupServices,
  getSubServicesCategory,
} from "../../../../api/service";
import { useParams } from "react-router-dom";

const SubServiceModal = ({
  onCancel,
  onOk,
  text,
  title,
  promo,
  subserviceId,
  parentServiceId,
}) => {
  const businessId = useParams();
  const [subserviceData, setSubServiceData] = useState();
  const [serviceData, setServiceData] = useState();
  const fetchSubServiceCategoryList = async () => {
    const res = await getSubServicesCategory();
    if (res) {
      setSubServiceData(res);
    }
  };
  const fetchServicesList = async () => {
    const res = await getLookupServices(businessId.id);
    if (res) {
      setServiceData(res);
    }
  };
  useEffect(() => {
    fetchSubServiceCategoryList();
    fetchServicesList();
  }, []);
  const CustomOkButton = ({ onClick }) => (
    <Button
      title="Save"
      onClick={onClick}
      className="bg-lightBlue !text-black w-full focus:bg-primaryBlue !focus:text-white sm:w-19 h-5.4 !hover:shadow-none"
    />
  );
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        className="space-y-20"
        onCancel={onCancel}
        width="479px"
      >
        <h3>{title}</h3>
        <p>{text}</p>
        <p>{promo}</p>
        <div className="flex flex-col space-y-2">
          <Dropdown
            placeholder={"Select Parent"}
            data={serviceData}
            onChange={(e) => parentServiceId(e)}
          />
          <Dropdown
            placeholder={"Select Sub-service Category"}
            data={subserviceData}
            onChange={(e) => subserviceId(e)}
          />
        </div>
        <div className="flex space-x-2 sm:space-x-0 flex-row justify-between mt-2">
          <CustomOkButton onClick={onOk} />
        </div>
      </Modal>
    </div>
  );
};
export default SubServiceModal;
